interface Props {
  text: string;
}

export function GarageNotBookablePill({ text }: Props) {
  return (
    <div className="inline-flex items-center rounded-full border border-gray-300 py-[3px] px-3 before:content-[''] before:inline-block before:w-1.5 before:h-1.5 before:bg-rose-500 before:rounded-full before:mr-2">
      {text}
    </div>
  );
}
